/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Connections_Outlook_Enable_DescriptionInputs */



/**
* | output |
* | --- |
* | "Turn on Outlook tools for a mailbox you've already connected. The assistant reuses that connection, so there is no extra sign-in." |
*
* @param {Connections_Outlook_Enable_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const connections_outlook_enable_description = /** @type {((inputs?: Connections_Outlook_Enable_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connections_Outlook_Enable_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktivieren Sie Outlook-Tools für ein bereits verbundenes Postfach. Der Assistent nutzt diese Verbindung erneut, ohne erneute Anmeldung.")
	return /** @type {LocalizedString} */ ("Turn on Outlook tools for a mailbox you've already connected. The assistant reuses that connection, so there is no extra sign-in.")
});